export enum ApprobationAndCloseExplanationDialogFormLabelsEnum {
  TITLE = 'Dispute Closing Explanation',
  DESCRIPTION = 'Please explain the reason for closing',
  REASON_CODE = 'Decision Reason Code',
  REASON_EXPLANATION = 'Reason Explanation',
  SUBMIT = 'Close Dispute',
  CANCEL = 'Cancel',
}
